// Composable que devuelve un ref reactivo con la posición vertical del scroll.
// Usa requestAnimationFrame para throttling (solo se actualiza 1 vez por frame).
// El listener es passive para no bloquear el scroll en mobile.
//
// Uso:
//   const scrollY = useScrollY();
//   // scrollY.value === window.scrollY

import { ref, onMounted, onBeforeUnmount } from "vue";

export function useScrollY() {
  const scrollY = ref(
    typeof window !== "undefined"
      ? window.scrollY || window.pageYOffset || 0
      : 0,
  );

  let rafId = null;

  function onScroll() {
    // Si ya hay un rAF pendiente, no encolamos otro.
    if (rafId !== null) return;
    rafId = requestAnimationFrame(() => {
      scrollY.value = window.scrollY || window.pageYOffset || 0;
      rafId = null;
    });
  }

  onMounted(() => {
    if (typeof window === "undefined") return;
    window.addEventListener("scroll", onScroll, { passive: true });
    // Set inicial (puede haber cambiado entre la creación del ref y el mount)
    scrollY.value = window.scrollY || window.pageYOffset || 0;
  });

  onBeforeUnmount(() => {
    if (typeof window === "undefined") return;
    window.removeEventListener("scroll", onScroll);
    if (rafId !== null) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
  });

  return scrollY;
}
